import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import LanguageDropDown from '../buttons/language';

const RestaurantHeader = ({ restaurant, table, canHomeNavigate }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [noBanner, setNoBanner] = useState(!!restaurant.bannerUrl);
  const [noLogo, setNoLogo] = useState(!!restaurant.logoUrl);

  useEffect(() => {
    if (restaurant) {
      setNoBanner(!restaurant.bannerUrl);
      setNoLogo(!restaurant.logoUrl);
    }
  }, [restaurant]);

  const getBannerClassesByType = () => {
    if (!restaurant || !restaurant.expandBannerType || restaurant.expandBannerType === 'Width') {
      return 'w-full';
    }

    if (restaurant.expandBannerType === 'Height') {
      return 'h-full';
    }

    return 'h-full w-full';
  };

  return (
    <div className="-mx-5">
      <div
        role={canHomeNavigate ? 'button' : undefined}
        onClick={canHomeNavigate ? () => navigate('/') : undefined}
      >
        {!noBanner && (
          <div className="h-56 w-full overflow-hidden rounded-b-2xl flex justify-center">
            <img
              className={`object-cover object-center ${getBannerClassesByType()}`}
              src={restaurant.bannerUrl}
              alt="Restaurant"
              onError={() => {
                setNoBanner(true);
              }}
            />
          </div>
        )}
        {!noLogo && (
          <div
            className={`${noBanner ? 'relative mt-5' : 'absolute top-56 -translate-y-1/2'}
            left-1/2 transform -translate-x-1/2
            h-28 w-28 overflow-hidden rounded-full bg-white`}
          >
            <img
              className="w-full h-full object-cover object-center"
              src={restaurant.logoUrl}
              alt="Logo"
              onError={() => {
                setNoLogo(true);
              }}
            />
          </div>
        )}
      </div>

      <div className="p-5">
        <LanguageDropDown />
      </div>

      <div className="mt-3">
        <p className="font-primaryMedium text-base text-bland text-center">
          {t('common.tableNo')} {table.number}
        </p>
      </div>
    </div>
  );
};

export default RestaurantHeader;
